import { Control, FieldErrors } from 'react-hook-form';
import { RaterData } from '../../../views/principal_rater_form_input/RaterInputForm';
import * as yup from 'yup';
import CollapseRaterInput from './CollapseRaterInput';

export default CollapseRaterInput;

export interface CollapseRaterInputProps {
  title: string;
  control: Control;
  data: RaterData[];
  errors: FieldErrors;
  notesExpectation?: any[];
  type: 'rater' | 'expectation';
}
